import { sendAnalytics } from 'shared/utils/analytics';

const trackInfrastructureMapOpen = (openingPlace: string) =>
  sendAnalytics({
    action: 'click',
    label: 'map',
    page: {
      extra: {
        openingPlace,
      },
    },
  });

export const trackInfrastructureMapOpenByMapFragment = () => trackInfrastructureMapOpen('infrastructure');

export const trackInfrastructureMapOpenByCategory = (infrastructureType: string) =>
  trackInfrastructureMapOpen(infrastructureType);
